export function toFixedLimit(val: number, maxFractionDigits: number): string {
    const str = val.toFixed(maxFractionDigits);
    let end = str.length;
    while (end > 0 && str.charCodeAt(end - 1) == 48) end--;
    if (end > 0 && str.charCodeAt(end - 1) == 46) end--;
    return end < str.length ? str.substring(0, end) : str;
}
